import React from 'react';

const JS_2021 = () => {
  return (
    <div >
      <h1>JS_2021</h1>
      <p>Placeholder component for: "JS 2021"</p>
    </div>
  );
};

export default JS_2021;
